<template>
  <mg-dialog
    :show.sync="dialogVisible"
    :title="isAdd ? '添加收货地址' : '编辑收货地址'"
    size="middle"
    class="address-edit-dialog"
    :class="{ 'address-edit-dialog__h5': isH5 }"
    :append-to-body="true"
    @cancel="cancel"
  >
    <el-form
      :model="addressForm"
      status-icon
      :rules="rules"
      size="small"
      ref="addressForm"
      label-width="80px"
    >
      <el-form-item label="收货人" prop="name">
        <el-input
          v-model="addressForm.name"
          autocomplete="off"
          placeholder="请输入收货人真实姓名"
          @input="handleInputName"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input
          v-model.number="addressForm.mobile"
          autocomplete="off"
          placeholder="请输入手机号"
          @input="handleInputPhone"
        ></el-input>
      </el-form-item>
      <el-form-item label="省市地区" prop="province">
        <select-address v-model="addressForm.province" valueType="object" />
      </el-form-item>
      <el-form-item label="详细地址" prop="address">
        <el-input
          type="textarea"
          v-model="addressForm.address"
          placeholder="建议如实填写详细地址和门牌号信息"
        ></el-input>
      </el-form-item>
      <el-form-item label="" prop="is_default">
        <el-checkbox
          v-model="addressForm.is_default"
          :true-label="1"
          :false-label="0"
          >设为默认地址</el-checkbox
        >
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="close" class="el-button__cancel" size="medium"
        >取 消</el-button
      >
      <el-button type="primary" size="medium" @click="submitForm"
        >确 认</el-button
      >
    </div>
  </mg-dialog>
</template>

<script>
import { provide } from "vue";
import MgDialog from "../mg-dialog/Index.vue";
import SelectAddress from "../select-address/Index.vue";
import { saveAddress } from "@saas/server-api/src/address/index.js";
import { isH5, isMobile } from "@saas/components/src";

export default {
  props: {
    addressInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      timer: null,
      isH5: isH5(),
      addressForm: {},
      rules: {
        name: [
          { required: true, message: "收货人不能为空", trigger: "blur" },
          {
            min: 1,
            max: 16,
            message: "收货人名称过长，请输入16字以内",
            trigger: "",
          },
        ],
        mobile: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            min: 11,
            max: 11,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        province: [
          {
            required: true,
            type: "array",
            message: "请选择所在地区",
          },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
          {
            min: 2,
            max: 50,
            message: "详细地址需要在2-50字之间",
          },
        ],
      },
    };
  },
  computed: {
    isAdd() {
      return !this.addressInfo.id;
    },
  },
  watch: {
    addressInfo: {
      handler(val) {
        if (val.id) {
          this.addressForm = {
            ...val,
            mobile: val.mobile + "",
            province: [
              { id: val.province_id + "", name: val.province },
              { id: val.city_id + "", name: val.city },
              { id: val.district_id + "", name: val.district },
            ],
          };
        } else {
          this.addressForm = {
            is_default: 0,
          };
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    close() {
      this.dialogVisible = false;
    },
    open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.addressInfo.id) {
          this.addressForm = {
            ...this.addressInfo,
            mobile: this.addressInfo.mobile + "",
            province: [
              {
                id: this.addressInfo.province_id + "",
                name: this.addressInfo.province,
              },
              {
                id: this.addressInfo.city_id + "",
                name: this.addressInfo.city,
              },
              {
                id: this.addressInfo.district_id + "",
                name: this.addressInfo.district,
              },
            ],
          };
        } else {
          this.addressForm = {
            is_default: 0,
          };
        }
        this.$refs.addressForm?.clearValidate();
      });
    },
    cancel() {
      this.$emit("cancel");
    },
    submitForm() {
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          saveAddress({
            ...this.addressForm,
            mobile: +this.addressForm.mobile,
            id: this.addressForm.id || undefined,
            province: this.addressForm.province?.[0].name,
            province_id: +this.addressForm.province?.[0].id,
            city: this.addressForm.province?.[1].name,
            city_id: +this.addressForm.province?.[1].id,
            district: this.addressForm.province?.[2].name,
            district_id: +this.addressForm.province?.[2].id,
          }).then((res) => {
            if (res.code === 1) {
              this.$emit("success");
              this.addressForm = {
                is_default: 0,
              };
              this.dialogVisible = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    handleInputName(val) {
      // 去掉非数字和汉字的字符
      val = val.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, "");
      this.addressForm.name = val;
    },
    handleInputPhone(val) {
      val = val.replace(/[^0-9]/g, "");
      val = val.slice(0, 11);
      this.addressForm.mobile = val;
    },
  },
  components: {
    MgDialog,
    SelectAddress,
  },
};
</script>

<style scoped lang="scss">
.address-edit-dialog ::v-deep {
  .el-dialog {
    border-radius: 16px;
    width: 580px;
  }
  .el-dialog__body {
    padding: 0 20px 25px 20px !important;
  }
  .el-form {
    margin-top: 20px;
  }
  .footer {
    text-align: right;
  }
  .el-dialog__header {
    padding-top: 22px !important;
    .el-dialog__title {
      font-size: 18px;
    }
  }
}
.address-edit-dialog__h5 ::v-deep {
  .el-dialog {
    width: 9.3333rem;
    max-height: 80%;
    overflow: auto;
  }
  .el-dialog__body {
    padding: 0 0.5333rem 0.6667rem 0.5333rem !important;
  }
  .el-form {
    margin-top: 0.5333rem;
  }
  .footer {
    text-align: right;
  }
  .el-dialog__header {
    padding-top: 0.5867rem !important;
    .el-dialog__title {
      font-size: 0.48rem;
    }
  }
}
</style>
